module.exports = __webpack_public_path__ + "img/premiering_background@1x.7c2fce5d.png";